import { AlertTriangle, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useSubscriptionStatus } from '@/api/subscription'
import { useCustomerPortal } from '@/api/stripe'

/**
 * Bannière fine affichée en haut du dashboard quand le SORTANT du compte est
 * en retard de paiement ou suspendu pour impayé. L'entrant reste toujours
 * actif. L'état est calculé côté backend (champ `outbound_banner`, qui gère
 * aussi la suspension manuelle admin) : on le lit tel quel.
 *
 * Le CTA ouvre le Stripe Billing Portal (`create-customer-portal`) pour que le
 * client règle/mette à jour son moyen de paiement et réactive le sortant.
 */
export function OutboundSuspendedBanner() {
  const { t, i18n } = useTranslation()
  const { data } = useSubscriptionStatus()
  const portal = useCustomerPortal()

  // Champ top-level en priorité : calculé sur l'abonnement du propriétaire de
  // la company, il couvre aussi les agents invités (sans abonnement propre).
  const banner = data?.outbound_banner ?? data?.subscription?.outbound_banner ?? 'none'
  if (banner !== 'suspended' && banner !== 'late') return null

  return (
    <div
      role="alert"
      className="flex items-center gap-3 px-4 py-2 text-sm font-medium text-amber-900 bg-amber-100 border-b border-amber-200"
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <span className="min-w-0 flex-1">
        {banner === 'suspended' ? t('billingBanner.suspended') : t('billingBanner.late')}
      </span>
      <button
        type="button"
        onClick={() => portal.mutate(i18n.language)}
        disabled={portal.isPending}
        className="inline-flex flex-shrink-0 items-center gap-1.5 rounded-md bg-amber-900 px-3 py-1 text-xs font-semibold text-amber-50 transition-colors hover:bg-amber-800 disabled:opacity-60"
      >
        {portal.isPending && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
        {t('billingBanner.cta')}
      </button>
    </div>
  )
}
